export function convertDateToUTC (date: Date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}
export function convertDateStringToUTCDate (dateISOString: string): Date | null {
  if (!dateISOString) {
    return null;
  }
  let date = new Date(dateISOString);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/dateUtil.ts